
<div v-if="folder" class="h-100 w-100">
    <c-column-header
        class = "primary white--text"
        label = "ELO Wartungsberichte"
    >
        <template v-slot:filter>
            <div style="margin-top: -2px; margin-right: 4px;">
                <c-toolbar-button
                    v-model  = "showAll"
                    :icon    = "showAll ? 'mdi-filter' : 'mdi-filter-off'"
                    :tooltip = "showAll ? 'Alle Dokumente' : 'Dokumente im Zeitintervall'"
                    color    = "white"
                    size     = "20"
                    @click   = "onFilter ()"
                />
            </div>
        </template>
    </c-column-header>

    <div style="overflow-y: scroll; max-height: calc(100% - 30px); width: calc(100% + 8px)" class="pt-1">
        <v-card
            flat
            @click="onClick(entry)"
            v-for="(entry,index) in entries (showAll)"
            :key="'xxx' + index"
            class=" mb-1 pl-2"
            style="max-height: 26px; height: 26px; padding-top: 1px; margin-right: 2px;"
            :class="selected && selected.guid === entry.guid ? 'primary white--text pl-1 pr-1' : ''"
        >
            <v-row class="no-frame  pa-0"  style="font-size: 14px; ">
                <v-col class="no-frame col-2">
                    {{ date( entry.created) }}
                </v-col>
                <v-col class="no-frame col-8"  style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis;">
                    {{ entry.name }}
                </v-col>
                <v-col class="no-frame col-2">
                    {{ entry.owner }}
                </v-col>
            </v-row>
        </v-card>
    </div>
</div>
